import React from 'react';
import SmartDisplayOutlinedIcon from '@mui/icons-material/SmartDisplayOutlined';
import useStore from '../state/KioskStore';
import { useSearchParams } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';

export const KioskPlayButton = () => {
  const store = useStore((state) => state);
  const [searchParams, setSearchParams] = useSearchParams();

  const setKioskMode = () => {
    store.reset();
    store.setMode('kiosk');

    searchParams.delete('site');
    searchParams.delete('time-range');
    searchParams.set('mode', 'kiosk');
    setSearchParams(searchParams);
  };

  const styles = {
    csvDownload: {
      backgroundColor: 'RGBA(255, 255, 255, 0.8)',
      color: '#E1E2E4',
      '&:hover': {
        backgroundColor: 'RGBA(240, 240, 240, 0.8)',
      },
    },
    csvIcon: {
      position: 'relative',
      right: '-2px',
      color: '#939393',
      fontSize: '30px',
    },
  };

  return (
    <Tooltip title="Play Fullscreen Loop">
      <Button onClick={setKioskMode} variant="outlined" color="inherit" sx={styles.csvDownload}>
        <SmartDisplayOutlinedIcon fontSize="inherit" sx={styles.csvIcon} />
      </Button>
    </Tooltip>
  );
};
